import StarIcon from '@mui/icons-material/Star';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import PersonIcon from '@mui/icons-material/Person';

// Given a lease link (or any { HouseholdStatus, IsHeadOfHousehold }), return the
// icon component + colour + label describing that member's household role.
// Shared by the applicant tabs and the audit trail so the two stay consistent:
//   star = Head of Household, caring-hands = Live-In Aide, child = Minor,
//   person = other adult co-applicant.
export const roleBadge = ({ HouseholdStatus, IsHeadOfHousehold } = {}) => {
  const status = (HouseholdStatus ?? '').toLowerCase();
  if (IsHeadOfHousehold || status === 'head of household') {
    return { Icon: StarIcon, color: 'primary', label: 'Head of Household' };
  }
  if (status.includes('live-in aide')) {
    return { Icon: VolunteerActivismIcon, color: 'secondary', label: 'Live-In Aide' };
  }
  if (status.includes('minor')) {
    return { Icon: ChildCareIcon, color: 'warning', label: 'Minor' };
  }
  return { Icon: PersonIcon, color: 'disabled', label: HouseholdStatus || 'Applicant' };
};
